import debug from "debug";

import plugin from '../../lib/plugin';

const MODULE_NAME = 'app.core/modules/toggle-disable';
const log = debug(MODULE_NAME);

const ELEMENT_SELECTOR = '[data-toggle-disable]';

function toggleDisabled () {
    const target = this.options.target;

    if ($(target).is(':disabled') ) {
        $(target).removeAttr('disabled');
    } else {
        $(target).attr('disabled','disabled');
    }
}

function disableIfUnchecked (instance) {
    const target = instance.options.target;
    const $trigger = instance.$element;

    if ($trigger.is(':checked')) {
        $(target).removeAttr('disabled');
    } else {
        $(target).attr('disabled','disabled');
    }
}



class ToggleDisable {
    constructor(element, options) {
        this.element = element;
        this.options = options;
        this.$element = $(element);
        log('ToggleDisable', element, options);
        this.watch();
    }

    watch() {
        this.$element.on('click.toggleDisable', toggleDisabled.bind(this));

        disableIfUnchecked(this);

        log('bound', this.element);
    }

    unwatch() {
        this.$element.off('.toggleDisable');
        log('unbound', this.element);
    }
}

ToggleDisable.DEFAULTS = {};

plugin('toggleDisable', ToggleDisable);

export function exec() {
    $(document).on('async_update', function (event, context) {
        $(context).find(ELEMENT_SELECTOR).toggleDisable();
    });

    $(document).ready(() => {
        $(ELEMENT_SELECTOR).toggleDisable();
    });

}





// WEBPACK FOOTER //
// ./client/src/core/modules/toggle-disable/index.js